import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LayoutService } from '../../../layout/services/layout.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle = '';
  @Input() textColor = 'white';
  @Input() iconColor: string;
  @Input() closeIconPath = 'assets/images/close.svg';
  @Input() applyModalPage = false;
  @Input() maxWidth = '1440';
  @Input() padding = '0';
  @Input() applyHeaderStyle = true;
  @Input() contentFillTheScreen: boolean = false;
  @Input() backgroundColor = 'white';
  @Output() closeClicked = new EventEmitter<any>();
  @Input() closable = true;
  @Input() editCloseIcon = false;

  isModalOpened = false;
  isVisible = false;

  constructor(
    public layoutService: LayoutService
  ) { }

  ngOnInit() {
  }

  showModal() {
    this.isModalOpened = true;
  }

  closeModal() {
    this.isModalOpened = false;
  }

  closeCurrentModal() {
    this.closeClicked.emit(null);
    this.isModalOpened = false;
  }

}
